import { render, staticRenderFns } from "./ClipboardCopy.vue?vue&type=template&id=10e82b3e&scoped=true&"
import script from "./ClipboardCopy.vue?vue&type=script&lang=ts&"
export * from "./ClipboardCopy.vue?vue&type=script&lang=ts&"
import style0 from "./ClipboardCopy.vue?vue&type=style&index=0&id=10e82b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e82b3e",
  null
  
)

export default component.exports